import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(stroke => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-2 -2 85 90"
}, /*#__PURE__*/React.createElement("path", {
  stroke: stroke,
  strokeWidth: "2%",
  d: "M23.62 24.21a3.56 3.56 0 1 0 3.55 3.55 3.55 3.55 0 0 0-3.55-3.55zM37.7 58.56h26.19v-4.74H37.7zm0-14.22h26.19v-4.73H37.7zm-7-19v4.74h33.19v-4.69z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: stroke,
  strokeWidth: "2%",
  d: "M42 0a42 42 0 1 0 42 42A42 42 0 0 0 42 0zm0 76.46A34.49 34.49 0 1 1 76.46 45 34.49 34.49 0 0 1 45 76.46z"
})), 'HBCTreeExpand');